import { FC, memo, useEffect, useRef } from 'react'
import classNames from 'classnames'

import css from './BaseVideo.module.scss'

export interface BaseVideoProps {
  className?: string
  url: string
}

export interface ViewProps extends BaseVideoProps {}

// View (pure and testable component, receives props from the controller)
export const View: FC<ViewProps> = ({ className, url }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)

  useEffect(() => {
    if (!videoRef.current) return

    const video = videoRef.current

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          void video.play()
        } else {
          video.pause()
        }
      },
      {
        threshold: 0.5
      }
    )

    observer.observe(video)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div className={classNames('BaseVideo', css.root, className)}>
      <video className={css.video} ref={videoRef} controls={false} loop={true} muted={true} playsInline={true}>
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

View.displayName = 'BaseVideo-View'

// Controller (handles global state, router, data fetching, etc. Feeds props to the view component)
const BaseVideo: FC<BaseVideoProps> = (props) => {
  return <View {...props} />
}

export default memo(BaseVideo)
